module.exports = __webpack_public_path__ + "img/9347815.png";